// extracted by mini-css-extract-plugin
export default {"component":"slider_component__o3C0h","slider":"slider_slider__lDIje","list":"slider_list__Ojyo+","item":"slider_item__ft0P6"};